export default __webpack_public_path__ + "static/media/menu-18x14.ca9833db.svg";